<template>
  <ObjectiveMoveModal
    :disable="isDisable"
    :loading="loading"
    :show="show"
    :title="t('objective.select_group')"
    @close="hideModal"
    @proceed="proceed"
    @prev-step="prevStep"
  >
    <AppInfoMessage :type="INFO_MESSAGE_TYPES.WARNING" class="sgm-Subtitle">
      {{ t('move.select_groups_subtitle') }}
    </AppInfoMessage>

    <ObjectiveMoveConflictItems
      :conflict-items="conflicts"
      :search-function="str => getGroups(str)"
      :select-items="groupOptionsMapped"
      :select-placeholder="$t('objective.select_group')"
      :selected-items="selectedGroups"
      @update:model-value="updateConflict"
      @update:options="groupOptions = $event"
    >
      <template #prepend-select-icon="{ selectedItem }">
        <GroupIcon v-if="selectedItem" :color="selectedItem.color" :icon-name="selectedItem.icon" />
      </template>

      <template #select-option-label="{ option }">
        <GlobalGroupsSelectOption v-if="option" :group="option" />
      </template>
    </ObjectiveMoveConflictItems>
  </ObjectiveMoveModal>
</template>

<script setup>
import { nextTick, ref, onMounted, computed } from 'vue'
import { useI18n } from 'vue-i18n'

import GlobalGroupsApiHandler from '@/api/global-groups'
import { INFO_MESSAGE_TYPES } from '@/utils/components-configurations/app-info-message'
import { handleError } from '@/utils/error-handling'

import GlobalGroupsSelectOption from '@/components/global-groups/GlobalGroupsSelectOption'
import GroupIcon from '@/components/global-groups/GroupIcon'
import ObjectiveMoveConflictItems from '@/components/objectives/objective-move/ObjectiveMoveConflictItems'
import ObjectiveMoveModal from '@/components/objectives/objective-move/ObjectiveMoveModal'
import AppInfoMessage from '@/components/ui/AppInfoMessage'

const props = defineProps({
  show: {
    type: Boolean
  },
  formModel: {
    type: Object,
    required: true
  },
  conflicts: {
    type: Array,
    default: () => []
  },
  loading: {
    type: Boolean
  }
})
const { t } = useI18n()

const emit = defineEmits({
  'update:show': null,
  proceed: null,
  'prev-step': null
})

const hideModal = async () => {
  emit('update:show', false)
  await nextTick()
}

const proceed = () => {
  const conflictGroups = props.conflicts.map((conflict, conflictIndex) => {
    return {
      ...conflict,
      idToChange: selectedGroups.value[conflictIndex]
    }
  })
  emit('proceed', conflictGroups)
}

const prevStep = () => {
  emit('prev-step')
}

const areGroupsLoading = ref(false)
const groupOptions = ref([])
const selectedGroups = ref(props.conflicts.map(conflict => conflict.idToChange))

const groupOptionsMapped = computed(() => {
  return [
    // { name: t('objective.clear_group'), id: null, iconName: 'unassigned-owner' },
    ...groupOptions.value
  ]
})
const updateConflict = ({ index, value }) => {
  selectedGroups.value[index] = value
}
const getGroups = async (searchString = null) => {
  const groupIds = searchString
    ? null
    : props.conflicts.map(conflict => conflict.idToChange).filter(Boolean)
  const api = new GlobalGroupsApiHandler()
  areGroupsLoading.value = true
  try {
    return await api.getGroupsForFilter({
      searchString,
      workspaceIds: [props.formModel.workspaceId],
      groupIds
    })
  } catch (error) {
    handleError({ error })
  } finally {
    areGroupsLoading.value = false
  }
}
const isDisable = computed(() => {
  // return false
  return selectedGroups.value.some(group => !group)
})
onMounted(async () => {
  groupOptions.value = await getGroups()
})
</script>
<script>
//eslint-disable-next-line import/order
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'SelectGroupModal'
})
</script>

<style lang="scss" scoped>
.sgm-Subtitle {
  margin-bottom: 35px;
}
</style>
